import { render, staticRenderFns } from "./ChartTree.vue?vue&type=template&id=15345e60"
import script from "./ChartTree.vue?vue&type=script&lang=js"
export * from "./ChartTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports